"use client";

import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { MapPin, Phone, Mail, Loader } from "lucide-react";
export default function Contacto() {
  return <section id="contacto" className="bg-background text-foreground py-12 md:py-9 lg:py-12 px-4">
      <div className="container">
        <div className="grid lg:grid-cols-[40%_60%] gap-10 items-start">
          {}
          <div className="space-y-12">
            <div>
              <h2 className="font-serif text-4xl font-medium mb-4">
                Hablemos
              </h2>
              <p className="font-sans text-muted-foreground text-lg leading-relaxed">
                Estamos aquí para responder tus preguntas sobre nuestro aceite, 
                colaboraciones comerciales o próximas catas.
              </p>
            </div>

            <div className="space-y-8">
              <div className="flex items-start gap-4">
                <div className="shrink-0">
                  <MapPin className="size-6 text-primary" />
                </div>
                <div>
                  <h3 className="font-serif text-xl font-medium mb-1">Ubicación</h3>
                  <p className="font-sans text-muted-foreground leading-relaxed">La Haya, Países Bajos</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="shrink-0">
                  <Phone className="size-6 text-primary" />
                </div>
                <div>
                  <h3 className="font-serif text-xl font-medium mb-1">Teléfono</h3>
                  <p className="font-sans text-muted-foreground leading-relaxed">+31 6 38 47 47 29</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="shrink-0">
                  <Mail className="size-6 text-primary" />
                </div>
                <div>
                  <h3 className="font-serif text-xl font-medium mb-1">Email</h3>
                  <p className="font-sans text-muted-foreground leading-relaxed">aceitepacoyherminia@gmail.com</p>
                </div>
              </div>
            </div>
          </div>

          {}
          <FormProvider className="bg-card rounded-md p-8" formId="contact_form_home" sectionName="contacto" defaultValues={{
          name: "",
          email: "",
          phone: "",
          company: "",
          message: ""
        }} validationRules={{
          name: {
            required: true,
            minLength: 2,
            maxLength: 100
          },
          email: {
            required: true,
            pattern: "email"
          },
          phone: {
            required: false
          },
          company: {
            required: false
          },
          message: {
            required: true,
            minLength: 10
          }
        }} submitText="Enviar Mensaje" successMessage="¡Gracias! Hemos recibido tu mensaje y te responderemos pronto.">
            <ContactFormContent />
          </FormProvider>
        </div>
      </div>
    </section>;
}
function ContactFormContent() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="p-8 bg-primary/10 border border-primary/20 rounded-lg text-center">
        <p className="text-primary text-lg mb-6 font-sans">{successMessage}</p>
        <Button onClick={resetForm} className="btn w-full mx-auto">
          Enviar Otro Mensaje
        </Button>
      </div>;
  }
  return <div>
      <h3 className="font-serif text-2xl font-medium mb-2">
        Consulta Profesional
      </h3>
      <p className="font-sans text-muted-foreground mb-8">
        Completa el formulario y nos pondremos en contacto contigo.
      </p>

      <Form onSubmit={handleSubmit}>
        <div className="space-y-6">
          <FormField control={control} name="name" rules={{
          required: "El nombre es obligatorio",
          minLength: {
            value: 2,
            message: "Mínimo 2 caracteres"
          },
          maxLength: {
            value: 100,
            message: "Máximo 100 caracteres"
          }
        }} render={({
          field
        }) => <FormItem>
                <FormLabel className="font-sans uppercase tracking-widest text-xs">Tu Nombre</FormLabel>
                <FormControl>
                  {}
                  <Input placeholder="Juan Pérez" className="border-0 border-b border-foreground px-0 focus-visible:ring-0 font-sans" {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>} />

          <FormField control={control} name="email" rules={{
          required: "El email es obligatorio",
          pattern: {
            value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
            message: "Email inválido"
          }
        }} render={({
          field
        }) => <FormItem>
                <FormLabel className="font-sans uppercase tracking-widest text-xs">Dirección de Email</FormLabel>
                <FormControl>
                  {}
                  <Input type="email" placeholder="juan@example.com" className="border-0 border-b border-foreground px-0 focus-visible:ring-0 font-sans" {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>} />

          <FormField control={control} name="phone" rules={{}} render={({
          field
        }) => <FormItem>
                <FormLabel className="font-sans uppercase tracking-widest text-xs">Número de Teléfono</FormLabel>
                <FormControl>
                  {}
                  <Input type="tel" placeholder="+31 6 1234 5678" className="border-0 border-b border-foreground px-0 focus-visible:ring-0 font-sans" {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>} />

          <FormField control={control} name="company" rules={{}} render={({
          field
        }) => <FormItem>
                <FormLabel className="font-sans uppercase tracking-widest text-xs">Empresa / Organización</FormLabel>
                <FormControl>
                  {}
                  <Input placeholder="Delicatessen XYZ" className="border-0 border-b border-foreground px-0 focus-visible:ring-0 font-sans" {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>} />

          <FormField control={control} name="message" rules={{
          required: "El mensaje es obligatorio",
          minLength: {
            value: 10,
            message: "Mínimo 10 caracteres"
          }
        }} render={({
          field
        }) => <FormItem>
                <FormLabel className="font-sans uppercase tracking-widest text-xs">Mensaje</FormLabel>
                <FormControl>
                  <Textarea placeholder="Cuéntanos cómo podemos ayudarte..." className="min-h-32 resize-none border-0 border-b border-foreground px-0 focus-visible:ring-0 font-sans" {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>} />

          {submitError && <div className="p-4 bg-primary/10 border border-primary/20 rounded-lg">
              <p className="text-primary text-sm font-sans">{submitError}</p>
            </div>}

          <Button type="submit" disabled={isSubmitting} className="btn w-full">
            {isSubmitting ? <>
                <Loader className="animate-spin mr-2 size-4" />
                Enviando...
              </> : "Enviar Mensaje"}
          </Button>
        </div>
      </Form>
    </div>;
}